import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
// stylesheet
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/common.scss";
import "@frameworks/pmsjourney/pages/Features/OrderBook/orderbook.scss";
// components
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import MutualFundTransactionsTable from "@frameworks/shared-library/components/Orderbook/common/MutualFundTransactionsTable/MutualFundTransactionsTable";
import { tabData } from "../../../constants/constant";
var LobTable = function (props) {
    //
    var _a;
    var navigate = useNavigate();
    var handleNavigate = useCallback(function () {
        navigate("/dashboard/product-bouquet", {
            state: {
                select: {
                    label: "Managed Portfolio",
                    value: "56",
                    mfL3LevelData: tabData,
                },
                tabId: props.subCategoryId,
                productName: { label: "Wealth Product", value: "Wealth Product" },
            },
        });
    }, [navigate, props]);
    return (React.createElement("div", { className: "primary-mandate-transactions-container ".concat((_a = props === null || props === void 0 ? void 0 : props.parentClassName) !== null && _a !== void 0 ? _a : "primary-offerings-table-wrapper aif-pms-oof") },
        React.createElement(MutualFundTransactionsTable, { columns: props.tableColumns, data: props.tableData, showViewAll: props.showViewAll, viewAllOnClick: props === null || props === void 0 ? void 0 : props.viewAllOnClick, showShimmer: props === null || props === void 0 ? void 0 : props.showShimmer, selectedSortColumnVal: props.selectedSortColumnVal
                ? props.selectedSortColumnVal
                : String(props === null || props === void 0 ? void 0 : props.defaultSortingColumnKey), selectedSortVal: String(props === null || props === void 0 ? void 0 : props.selectedSortVal), errorScreenBtnCallback: handleNavigate, mfCustomError: React.createElement("div", { className: "error-state-button-bar flexCenter" },
                React.createElement("p", { className: "DMSanN_14_400" }, props.errorScreenMessage),
                React.createElement(EdButton, { btnTyp: "tomato", onClick: handleNavigate, value: "Invest Now!", className: "d-flex align-items-center justify-content-center DMSanN_13_500" })), callbackSorted: props === null || props === void 0 ? void 0 : props.callbackSorted })));
};
export default LobTable;
